var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { BackgroundImage } from "@alife/simple-ui";
import LazyLoad from "react-lazyload";
import "./index.scss";
var CardProductGoods = (function (_super) {
    __extends(CardProductGoods, _super);
    function CardProductGoods() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardProductGoods.prototype.render = function () {
        var _a = this.props, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, templateData = _a.templateData, _c = _a.locale, locale = _c === void 0 ? {} : _c, onClickButton = _a.onClickButton, isClicked = _a.isClicked, setIsClicked = _a.setIsClicked, button = _a.button;
        var picUrl = templateData.picUrl, title = templateData.title, price = templateData.price, oldPrice = templateData.oldPrice, _d = templateData.discount, discount = _d === void 0 ? "" : _d;
        var displayDiscount = discount.length > 0 && !discount.includes("-")
            ? "-" + discount
            : discount;
        return (React.createElement("div", { className: "card-product-goods", onClick: function () { return onClick(templateData); } },
            React.createElement("div", { className: "card-header-goods" }, button === "confirm"
                ? locale.confirmTitle
                : button === "select"
                    ? locale.skuTitle
                    : "Product Information"),
            React.createElement("div", { className: "card-content-goods" },
                React.createElement(LazyLoad, { overflow: true, once: true, height: 62 },
                    React.createElement(BackgroundImage, { src: picUrl, className: "lzd-pro-img" })),
                React.createElement("div", { className: "lzd-pro-desc-goods" },
                    React.createElement("div", { className: "lzd-pro-title-goods text-two-lines" }, title),
                    React.createElement("div", { className: "lzd-pro-price-goods text-overflow", title: price }, price),
                    React.createElement("div", { className: "lzd-pro-old-price-content-goods" },
                        React.createElement("span", { className: "lzd-pro-old-price-goods text-overflow", title: price }, oldPrice),
                        React.createElement("span", { className: "lzd-pro-discount-goods" }, displayDiscount)))),
            React.createElement("div", { className: "card-goods-button " + (isClicked ? "card-goods-clicked" : ""), onClick: function (e) {
                    e.stopPropagation();
                    if (!isClicked) {
                        onClickButton();
                        setIsClicked && setIsClicked(true);
                    }
                } }, button === "confirm"
                ? locale.confirm
                : button === "select"
                    ? locale.select
                    : "")));
    };
    return CardProductGoods;
}(React.Component));
export default CardProductGoods;

//# sourceMappingURL=index.js.map
